import VideoPlayerSdk from '@wix/thunderbolt-elements/src/components/VideoPlayer/corvid/VideoPlayer.corvid';


const VideoPlayer = {
  sdk: VideoPlayerSdk
};


export const components = {
  ['VideoPlayer']: VideoPlayer
};

